<template>
  <div :class="['container', { 'container-dark': theme_dark }]">
    <div class="nav-top fix">
      <div class="nav-left" @click="back()">
        <img src="../assets/img/返回箭头.png" class="nav-img" />
        <span class="nav-lable"></span>
      </div>
      <div class="nav-middle">新手指南</div>
      <div class="nav-right">
        <span class="nav-lable"></span>
        <img src="../assets/img/更换.png" class="nav-img none" />
      </div>
    </div>

    <div class="content">
      <div class="introduce">
        <span class="sp1">
          小火柴是一个<label>匿名</label>
          社交平台。在这里汇聚了150多万用户，主要集中在18-35岁之间的<label>单身小哥哥小姐姐</label>。这里<label>无需下载APP,无需注册，</label>也不看颜值，匿名的环境让你聊天轻松无压力，能够体验一次心灵的交流。在小火柴里都是<label>真人匹配</label>，100%的真实用户，可以畅所欲言，与懂自己的人即时互动或分享趣事。
        </span>
      </div>

      <div class="item">
        <div class="ub ub-pc title">
          <div class="tag"></div>
          <span class="sp2">在线匹配</span>
        </div>

        <span class="sp3 ub">
          在首页点击“随机匹配”即可与陌生人进行随机性的对话或交流（注意的是：每个用户每天免费随机匹配的次数为50次哦~），每次匹配到后和对方打个招呼，一般10次左右就有人回复你的；异性匹配是会员的特权功能，成为会员即可开启特权匹配！
        </span>

        <div class="image">
          <img class="img1" src="../assets/img/new2024/guidebook1.png" alt="" />
        </div>

        <div class="tips ub ub-pc ub-ac">
          <span>记住多匹配，多打招呼，全是真人哦</span>
        </div>

        <div class="image">
          <img class="img1" src="../assets/img/new2024/guidebook2.png" alt="" />
        </div>

        <div class="ub ub-pc title">
          <div class="tag"></div>
          <span class="sp2">聊天也能挣钱</span>
        </div>
        <span class="sp3 ub">
          你只需要每天登录小火柴，聊聊天就能有钱赚，当进行5次有效聊天时就可赚钱，让你轻轻松松赚两三百，同时，在聊天的过程中也可以加好友，送个礼物，礼物越多，积分越多，赚的也越多哦，你如果很感兴趣的话就去任务中心看看吧~。
        </span>

        <div class="image">
          <div class="ub">
            <span class="sp2">任务中心</span>
            <div class="decorate">
              <img src="../assets/img/new2024/bg-all.png" alt="" />
            </div>
          </div>
          <span class="sp3 ub">
                用户可参与任务中心的各项任务活动，完成任务后平台会给予一定数额的积分奖励。不同任务对应着不同的积分奖励，详情请点击“我的”→“我的钱包”→“积分奖励”进行查看。
          </span>
          <div class="ub ub-ac2 image">
            <img class="image2" src="../assets/img/new2024/guidebook3.png" alt="" />
            <img class="image2" src="../assets/img/new2024/guidebook4.png" alt="" />
          </div>
        </div>

        <div class="image">
          <div class="ub">
            <span class="sp2">我的收益</span>
            <div class="decorate">
              <img src="../assets/img/new2024/bg-all.png" alt="" />
            </div>
          </div>
          <span class="sp3 ub">
                在小火柴不仅可以聊天交友，还可以聊天挣钱。通过聊天提升个人魅力值便可进行收益提现，详情请点击“我的”→“我的钱包”→“挣钱攻略”进行查看。
          </span>
          <div class="ub ub-ac2 image">
            <img class="image2" src="../assets/img/new2024/guidebook3.png" alt="" />
            <img class="image2" src="../assets/img/new2024/guidebook5.png" alt="" />
          </div>
        </div>
        
        <div class="image">
          <div class="ub">
            <span class="sp2">师徒功能</span>
            <div class="decorate">
              <img src="../assets/img/new2024/bg-all.png" alt="" />
            </div>
          </div>
          <span class="sp3 ub">
            通过聊天向有经验的老玩家拜师，师父可以为你答疑解惑，指点迷津，更好的体验到交友的乐趣。详情请点击“我的”→“我的钱包”进行查看。
          </span>
          <div class="ub ub-ac2 image">
            <img class="image2" src="../assets/img/new2024/guidebook3.png" alt="" />
            <img class="image2" src="../assets/img/new2024/guidebook6.png" alt="" />
          </div>
        </div>

        <div class="image">
          <div class="ub">
            <span class="sp2">寻人区</span>
            <div class="decorate">
              <img src="../assets/img/new2024/bg-all.png" alt="" />
            </div>
          </div>
          <span class="sp3 ub">
            在这里可以自由地发表各种帖子、与他人交流各种思想，或者向大家分享自己的看法、经验以及感受，寻找志同道合的朋友~（点击下拉箭头可查看发帖人的微信号哦~，点击头像可以撩ta）
          </span>
        </div>

        <div class="image">
          <div class="ub">
            <span class="sp2">温馨提示</span>
            <div class="decorate">
              <img src="../assets/img/new2024/bg-all.png" alt="" />
            </div>
          </div>
          <span class="sp3 ub">
            在匹配后与聊天对象进行聊天时，可根据聊天情况点击聊天界面右上角三个点，进行修改备注、添加好友、一键拜师、举报、拉黑等操作。
          </span>
          <div class="image">
            <img class="img1" src="../assets/img/new2024/guidebook7.png" alt="">
          </div>
        </div>
      </div>

      <div class="to-chat ub ub-pc ub-ac">
        <div class="ub ub-ac ub-pc btn" @click="goto_index()"><span>去聊天</span></div>
      </div>

    </div>
  </div>
</template>
  
<script>
import * as tool from "../api/common";
export default {
  data() {
    return {
      theme_dark: false
    };
  },
  mounted() {
    //切换深色模式
    this.theme_dark = tool.is_theme_dark(this);
    this.init_page();
  },
  methods: {
    back() {
      this.$router.go(-1); //返回上一层
    },
    init_page() {
      
    },
    goto_index() {
      this.$router.push({ name: "index"});
    }
  },
};
</script>
  
<style lang="scss" scoped>
.container {
  min-height: 100vh;
  background-color: #efefef;
}
.content {
  .introduce {
    padding: 0.8rem;
  }
  .sp1 {
    font-size: 0.9rem;
    color: #565656;
    line-height: 1.3rem;
  }
  .sp2 {
    font-size: 1rem;
    font-weight: bold;
    color: #000;
  }
  .sp3 {
    margin-top: 1rem;
    font-size: 0.75rem;
    color: #333;
    line-height: 1.2rem;
  }
  label {
    color: #ba61ff;
  }
  .image {
    margin-top: 1rem;
    padding: 0.5rem;
    border: dotted 1px #e92162;
    border-radius: 0.5rem;
    .img1 {
      width: 100%;
      height: auto;
    }
  }
  .tips {
    margin-top: 1rem;
    span {
      font-size: 0.9rem;
      font-weight: bold;
      color: #000;
    }
  }
  .item {
    margin-top: 0.5rem;
    padding: 0.8rem;
    background-color: #ffffff;
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
  }
  .title {
    margin-top: 1rem;
  }
  .tag {
    width: 0.2em;
    height: 0.9em;
    background-color: #e92162;
    margin-right: 0.2em;
  }
  .decorate {
    img {
        width: 0.5rem;
        height: 0.5rem;
        margin-left: 0.2rem;
        margin-bottom: 0.5rem;
    }
  }
  .image2 {
    width: 10rem;
    height: auto;
  }
  .to-chat {
    position: fixed;
    width: 100%;
    bottom: 1rem;
    .btn {
    padding: 0.5rem 8rem;
    border-radius: 2rem;
    background: linear-gradient(86deg, rgba(162, 100, 231, 0.8), rgba(254, 156, 192, 0.8)) ;
    span {
      font-size: 0.9rem;
      font-weight: bold;
      color: #FFFFFF;
    }
  }
  }
}

.container-dark {
  background-color: #2f2e33;
  .content {
    .introduce {
      .sp1 {
        color: #fff;
      }
    }
    .item {
      background-color: #2c2b30;
      .sp2 {
        color: #fff;
      }
      .sp3 {
        color: #888;
      }
      .image {
        border: dotted 1px #404040;
      }
      .tips {
        span {
          color: #888;
        }
      }
    }
  }
}
</style>